import { render } from "./CouponsView.vue?vue&type=template&id=3aa7069a"
import script from "./CouponsView.vue?vue&type=script&lang=js"
export * from "./CouponsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__